import type { Currency } from "@/hooks/useCurrency";

interface CurrencyToggleProps {
  currency: Currency;
  onChange: (c: Currency) => void;
  className?: string;
}

export function CurrencyToggle({ currency, onChange, className = "" }: CurrencyToggleProps) {
  const isCAD = currency === "CAD";

  return (
    <div
      className={`inline-flex items-center gap-2.5 ${className}`}
      role="group"
      aria-label="Currency selection"
    >
      <span
        className={`text-sm font-semibold transition-colors duration-150 select-none ${
          isCAD ? "text-foreground" : "text-muted-foreground"
        }`}
        aria-hidden="true"
      >
        CAD
      </span>

      <button
        type="button"
        role="switch"
        aria-checked={!isCAD}
        aria-label={`Switch to ${isCAD ? "USD" : "CAD"} pricing`}
        onClick={() => onChange(isCAD ? "USD" : "CAD")}
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border-2 transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 cursor-pointer ${
          isCAD
            ? "bg-muted border-muted-foreground/20"
            : "bg-primary border-primary"
        }`}
      >
        <span
          className={`inline-block h-4 w-4 rounded-full bg-white shadow-sm transform transition-transform duration-150 ${
            isCAD ? "translate-x-0.5" : "translate-x-5"
          }`}
        />
      </button>

      <span
        className={`text-sm font-semibold transition-colors duration-150 select-none ${
          !isCAD ? "text-foreground" : "text-muted-foreground"
        }`}
        aria-hidden="true"
      >
        USD
      </span>
    </div>
  );
}
